import React from 'react'
import { connect } from 'react-redux'
import Modal from 'react-responsive-modal'
import accounting from 'accounting'
import Pagination from 'react-js-pagination'
import SwitchButton from '../../Components/SwitchButton'
import DestinationActions from '../../Redux/DestinationRedux'
import AttractionActions from '../../Redux/AttractionRedux'
import AttractionDetail from '../../Containers/Attraction/AttractionDetail'
import PlaceDetail from '../../Containers/Attraction/PlaceDetail'
import AttractionResetUpdate from '../../Containers/Attraction/AttractionResetUpdate'
import FormUpdateDetail from '../../Containers/Attraction/FormUpdateDetail'
import FormUpdateBanner from '../../Containers/Attraction/FormUpdateBanner'
import FormUpdateImage from '../../Containers/Attraction/FormUpdateImage'
import DownloadAttractionData from '../../Containers/Attraction/DownloadAttractionData'

class AttractionDefaultPage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      filter: {
        q: ''
      },
      setting: {
        ...props.setting
      },
      destination: '',
      selected: null,
      reverse: false,
      tab: 'attraction'
    }
  }

  componentDidMount () {
    this.props.getDestination()
  }

  // Lifecycle method below (for grabbing initial destination id) causes a
  // very hard to reproduce yet somewhat frequent timing glitch, so it's hidden.
  // componentWillReceiveProps = (newProps) => {
  //   let id = null
  //   if (newProps.destination.data.length) {
  //     id = newProps.destination.data[0].id
  //   }
  //   if (newProps.destination.data.length && !this.state.destination) {
  //     this.setState({ destination: id })
  //     this._fetchData(this.state.setting, id)
  //   }
  // }

  // This lifecycle method is useful to replace function above
  componentDidUpdate = (prevProps) => {
    if (this.props.destination !== prevProps.destination) {
      let id = null
      if (this.props.destination.data.length) {
        id = this.props.destination.data[0].id
      }
      if (this.props.destination.data.length && !this.state.destination) {
        this.setState({ destination: id })
        this._fetchData(this.state.setting, id)
      }
    }
  }

  _fetchData = (setting = this.state.setting, destination = this.state.destination, tab = null) => {
    const data = {
      destination,
      filter: {
        ...this.state.setting,
        ...setting,
        ...this.state.filter
      }
    }

    let activeTab = this.state.tab
    if (tab) {
      activeTab = tab
    }

    if (destination) {
      if (activeTab === 'attraction') {
        this.props.getAttraction(data)
      } else {
        data.filter.type = 'landmark'
        this.props.getPlace(data)
      }
    }
  }

  _destinationSelect = (event) => {
    const val = event.target.value
    this.setState({ destination: val })
    this._fetchData(null, val)
  }

  _presetChange = (event) => {
    const val = event.target.value
    const name = event.target.name
    let newState = { ...this.state.setting }
    newState[name] = val
    this.setState({
      setting: newState
    })

    this._fetchData(newState, this.state.destination)
  }

  _changePage = (page) => {
    this.setState({ page })
    const { setting, destination, filter } = this.state
    const data = {
      ...setting,
      page,
      ...filter
    }

    this._fetchData(data, destination)
  }

  _filterChange = (event, field) => {
    const val = event.target.value
    let newState = { ...this.state.filter }
    newState[field] = val
    this.setState({ filter: newState })
  }

  _applyFilter = (event) => {
    event.preventDefault()
    this._fetchData()
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
  }

  _selectAttraction = (data, action) => {
    this.setState({
      selected: data
    })

    this._toggleModal(action)
  }

  _toggleDisable = (event, id) => {
    let isDisabled = !event.target.value
    const data = { id, form: { is_disabled: isDisabled } }
    this.props.updateAttractionDetail(data)
    setTimeout(() => { this._fetchData() }, 500)
  }

  _changeTab = (tab = 'attraction') => {
    this.setState({ tab, page: 1 })
    const { setting, destination, filter } = this.state
    const data = {
      ...setting,
      ...filter
    }
    this._fetchData(data, destination, tab)
  }

  render () {
    const { destination, attraction } = this.props
    const { setting } = this.state
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3'>
            <h3 className='title mr-auto'>
              Attractions
              {
                (attraction.fetching || attraction.processing) &&
                <div className='badge badge-info ml-2'>{attraction.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
            {
              this.state.tab === 'attraction' &&
              <button onClick={() => this._toggleModal('download-attraction-data')} className='btn btn-primary'>Download Attraction Data</button>
            }
          </div>
          {/* <div className='btn-group mb-4' role='group'>
            <button className={`btn btn-primary ${(!this.state.tab || this.state.tab === 'attraction') && 'active'}`} onClick={() => this._changeTab()}>Attractions</button>
            <button className={`btn btn-primary ${(this.state.tab === 'landmark') && 'active'}`} onClick={() => this._changeTab('landmark')}>Landmarks</button>
          </div> */}
          <div className='title-block'>
            <p className='title-description'>Filter:</p>
            <div className='form-inline mb-2'>
              <div className='form-group mr-2'>
                <label className='control-label mr-1'>Language</label>
                <select className='form-control' name='language_code' value={setting.language_code} onChange={(event) => this._presetChange(event)}>
                  {this.props.preset.dataLanguage.map((lang, i) => (
                    <option key={i} value={lang.code === 'ind' ? 'ID' : (lang.code === 'eng' ? 'EN' : lang.code)}>{lang.code === 'ind' ? 'ID' : (lang.code === 'eng' ? 'EN' : lang.code)}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className='form-inline mb-2'>
              <div className='form-group mr-2'>
                <label className='control-label mr-1'>Provider</label>
                <select className='form-control' name='provider' value={setting.provider} onChange={(event) => this._presetChange(event)}>
                  <option value='BMG'>BMG</option>
                  <option value='KLOOK'>Klook</option>
                </select>
              </div>
            </div>
            <div className='form-inline d-flex justify-content-between'>
              <div className='form-group'>
                <label className='control-label mr-2'>Destination</label>
                <select className='form-control' value={this.state.destination} onChange={event => this._destinationSelect(event)}>
                  <option value='' disabled>- Select Destination -</option>
                  {
                    destination.data && destination.data.map((item, i) => {
                      return (
                        <option key={i} value={item.id}>{item.name}</option>
                      )
                    })
                  }
                </select>
              </div>
              {this.state.destination &&
                <form onSubmit={event => this._applyFilter(event)} className='form-inline'>
                  <div className='form-group'>
                    <label className='control-label mr-2'>Search by title</label>
                    <input type='text' name='title' className='form-control' onChange={event => this._filterChange(event, 'q')} />
                  </div>
                  <div className='form-group ml-1 mt-1'>
                    <button type='submit' className='btn btn-primary'>Apply Filter</button>
                  </div>
                </form>
              }
            </div>
          </div>
        </header>
        <section className='section' style={{ width: '110%' }}>
          {
            attraction.err &&
            <div className='alert alert-danger'>{attraction.err}</div>
          }
          {this.state.destination &&
            this.state.tab === 'attraction'
            ? <div className='card'>
              <div className='card-block'>
                <table className='table table-striped table-hover'>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>City</th>
                      <th>Price</th>
                      <th className='text-center'>Is Active?</th>
                      <th className='text-center'>Expiration Status</th>
                      <th>View</th>
                      <th className='text-center'>Action</th>
                      <th className='text-center'>Reset</th>
                    </tr>
                  </thead>
                  {
                    attraction.data !== undefined &&
                      <tbody>
                        {
                          (!attraction.data.data || !attraction.data.data.length)
                            ? <tr>
                              <td className='text-center' colSpan='8'>-- No Data --</td>
                            </tr>
                            : attraction.data.data.map((item, i) => {
                              return (
                                <tr key={i}>
                                  <td data-filter='title'>{item.title || '-'}</td>
                                  <td>{item.city ? item.city.name : '-'}</td>
                                  <td>
                                    {accounting.formatMoney(item.final_price, { symbol: setting.currency_code, format: '%s %v', thousand: ',', precision: 0 })}
                                  </td>
                                  <td className='text-center'>
                                    <SwitchButton isChecked={!item.is_disabled} onChange={(event) => this._toggleDisable(event, item.id)} />
                                  </td>
                                  <td className='text-center'>{item.is_expired ? 'Expired' : 'Available'}</td>
                                  <td>
                                    <button className='btn btn-primary' onClick={() => this._selectAttraction(item, 'view')}>
                                      <i className='fa fa-eye' />
                                    </button>
                                  </td>
                                  <td className='d-flex justify-content-around'>
                                    <button className='btn btn-primary' onClick={() => this._selectAttraction(item, 'update-detail')}>
                                      <i className='fa fa-edit' /> Edit
                                    </button>
                                    <button className='btn btn-primary' onClick={() => this._selectAttraction(item, 'update-banner')}>
                                      <i className='fa fa-image' /> Banner
                                    </button>
                                    <button className='btn btn-primary' onClick={() => this._selectAttraction(item, 'update-image')}>
                                      <i className='fa fa-image' /> Image
                                    </button>
                                  </td>
                                  <td>
                                    <button disabled={!item.is_ignored_on_update} className='btn btn-primary' onClick={() => this._selectAttraction(item, 'reset')}>
                                      <i className='fa fa-redo' /> Reset Update
                                    </button>
                                  </td>
                                </tr>
                              )
                            })
                        }
                      </tbody>
                  }
                </table>
              </div>
            </div>
            : <div className='card'>
              <div className='card-block'>
                <table className='table table-striped table-hover'>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  {
                    attraction.data !== undefined &&
                    <tbody>
                      {
                        (attraction.data.data && attraction.data.data.length) ? attraction.data.data.map((item, i) => {
                          return (
                            <tr key={i}>
                              <td data-filter='title'>{item.title || '-'}</td>
                              <td>
                                <button className='btn btn-primary' onClick={() => this._selectAttraction(item, 'view')}>
                                  <i className='fa fa-eye' />
                                </button>
                              </td>
                            </tr>
                          )
                        })
                          : <tr>
                            <td colSpan='2' className='text-center'>- No Data -</td>
                          </tr>
                      }
                    </tbody>
                  }
                </table>
              </div>
            </div>
          }

          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view'} onClose={this._toggleModal} closeOnOverlayClick>
            {
              this.state.tab === 'attraction'
                ? <AttractionDetail detailId={this.state.selected && this.state.selected.id} setting={this.state.setting} closeModal={() => this._toggleModal()} />
                : <PlaceDetail detailId={this.state.selected && this.state.selected.id} setting={this.state.setting} closeModal={() => this._toggleModal()} />
            }
          </Modal>

          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update-detail'} onClose={this._toggleModal} closeOnOverlayClick>
            <FormUpdateDetail detailId={this.state.selected && this.state.selected.id} setting={this.state.setting} closeModal={() => this._toggleModal()} />
          </Modal>

          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update-banner'} onClose={this._toggleModal} closeOnOverlayClick>
            <FormUpdateBanner detailId={this.state.selected && this.state.selected.id} setting={this.state.setting} closeModal={() => this._toggleModal()} />
          </Modal>

          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update-image'} onClose={this._toggleModal} closeOnOverlayClick>
            <FormUpdateImage detailId={this.state.selected && this.state.selected.id} setting={this.state.setting} closeModal={() => this._toggleModal()} />
          </Modal>

          <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'reset'} onClose={this._toggleModal} closeOnOverlayClick>
            <AttractionResetUpdate detailId={this.state.selected && this.state.selected.id} setting={this.state.setting} closeModal={() => this._toggleModal()} />
          </Modal>

          <Modal open={this.state.showModal === 'download-attraction-data'} onClose={this._toggleModal} closeOnOverlayClick>
            <DownloadAttractionData closeModal={() => this._toggleModal()} />
          </Modal>
        </section>

        <section className='text-center'>
          {
            ((this.state.destination && attraction.data) && attraction.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={attraction.data.page || this.state.page}
              itemsCountPerPage={10}
              totalItemsCount={attraction.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  destination: state.destination,
  attraction: state.attraction,
  preset: state.preset,
  setting: state.preset.setting
})

const dispatchToProps = (dispatch) => ({
  getDestination: () => dispatch(DestinationActions.destinationRequest()),
  getPlace: (data) => dispatch(AttractionActions.placeRequest(data)),
  getAttraction: (data) => dispatch(AttractionActions.attractionRequest(data)),
  updateAttractionDetail: (data) => dispatch(AttractionActions.attractionUpdateRequest(data)),
  clearCache: () => dispatch(AttractionActions.attractionClearCacheRequest())
})

export default connect(stateToProps, dispatchToProps)(AttractionDefaultPage)



// WEBPACK FOOTER //
// ./src/Pages/Attraction/Default.js